import { SantaErrorCode } from "./error-codes";

export class SantaError extends Error {
  public constructor(message: SantaErrorCode) {
    super(message);
  }
}
